import { Filter } from "lucide-react-native";
import { FC } from "react";

import { Pressable, Text } from "@/components/ui";
import { useLocalization } from "@/hooks";

interface FilterButtonProps {
  numFilters: number;
  onPress: () => void;
}

const FilterButton: FC<FilterButtonProps> = ({ numFilters, onPress }) => {
  const { i18n } = useLocalization();
  const active = numFilters > 0;

  return (
    <Pressable
      onPress={onPress}
      style={{
        alignItems: "center",
        borderColor: active
          ? "rgb(var(--color-primary-500))"
          : "rgb(var(--color-outline-300))",
        borderRadius: 8,
        borderWidth: 1,
        flexDirection: "row",
        gap: 6,
        // Match the shared 36px control height used across the results
        // toolbar (Gluestack Button `sm`, DropdownPicker `sm`, menu toggle).
        height: 36,
        justifyContent: "center",
        paddingHorizontal: 12,
      }}
    >
      <Filter
        color={
          active
            ? "rgb(var(--color-primary-500))"
            : "rgb(var(--color-typography-500))"
        }
        size={16}
      />
      <Text
        className="text-sm font-medium"
        style={{
          color: active
            ? "rgb(var(--color-primary-500))"
            : "rgb(var(--color-typography-600))",
        }}
      >
        {i18n.t("runs.filters")}
        {active ? ` (${numFilters})` : ""}
      </Text>
    </Pressable>
  );
};

export default FilterButton;
